/** @jsx jsx */
import { jsx } from '@emotion/core'
import _ from 'lodash'
import { BettingListSelector } from '@views/Popup/MessageContentPopup/BettingListSelector'
import {
  authStore,
  bettingHistoryStore, clubStore,
  companyPickStore, componentStore,
  globalStore,
  logStore,
  userPickStore, userStore, vocStore,
} from '@store/index'
import { UserPickEditor } from '@views/Home/UserPick/UserPickEditor'
import { PAGE_TYPE } from '@interface/common'
import { UserPickContents } from '@views/Home/UserPick/UserPickContents'
import { UserPickGiveawayInfo } from '@views/Home/UserPick/UserPickPage/UserPickGiveawayInfo'
import { PostingActivity } from '@views/MyPage/UserActivity/PostingActivity'
import { LikeActivity } from '@views/MyPage/UserActivity/LikeActivity'
import { FROM_VIEW_TYPE, USER_COMMENT_TYPE } from '@v2/constants/common'
import TodayUserPick from '@views/Home/UserPick/TodayUserPick'
import { UserDetailInfo } from '@views/Popup/UserDetailInfo'
import { CommentActivity } from '@views/MyPage/UserActivity/CommentActivity'
import { UserActivityScore } from '@views/MyPage/UserActivity/UserActivityScore'
import { ActivityHistory } from '@views/MyPage/UserActivity/ActivityHistory'
import { AdvComment } from '@components/AdvComment'
import { Schema$UserComment } from '@interface/comment'
import { AdvCommentEditor } from '@components/AdvComment/AdvCommentEditor'
import { UserBlockList } from '@views/MyPage/UserActivity/UserBlockList'
import { ShareBettingHistory } from '@views/MyPage/UserActivity/ShareBettingHistory'
import PopularSearchTermPopup from '@components/PopularSearchTerm/PopularSearchTermPopup'
import NewsPopup from '@components/PopularSearchTerm/NewsPopup'
import SourceUrlPopup
  from '@views/Matchup/MatchUpDetail/TabContent/SportTalkContents/SourceUrlPopup'
import { XEmbed, YouTubeEmbed } from 'react-social-media-embed'
import { SOURCE_URL_KIND, detectSourceUrlKind } from 'adv-lib/src/v2/utils/source-url-util'
import { Schema$PopularSearchTerm } from '@protocol/popularSearchTerm'
import { GeneralPopupOptions, PopupCloseType } from '@views/Popup/General'
import SportIssuePopup from '@views/Matchup/MatchUpDetail/TabContent/SportTalkContents/SportIssuePopup'
import AdvImg from '@components/AdvImg'
import { FavoriteUserList } from '@views/MyPage/UserActivity/FavoriteUser/FavoriteUserList'
import SportTalkPopup from '@views/Matchup/MatchUpDetail/TabContent/SportTalkContents/SportTalkPopup'
import { Schema$SportTalkPickUserInfo } from '@interface/sport-issue'
import { Schema$SimpleMatchTrack } from '@interface/matchup'
import MyPage from '@views/MyPage'
import BettorFind from '@views/BettorFind'
import BettingRules from '@views/BettingRules'
import BettingRulesDetail from '@views/Popup/BettingRulesDetail'
import Notice from '@views/Notice'
import NoticeDetail from '@views/Popup/NoticeDetail'
import Club from '@views/Club'
import ItemShop from '@views/ItemShop'
import TelegramGuide from '@views/TelegramGuide'
import { isMobile } from 'react-device-detect'
import { CompanyPickDetailPopup } from '@views/Popup/CompanyPickDetail'
import FriendsInvitation from '@views/FriendsInvitation'
import { UploadMessageImgStyle } from '@views/Popup/MessageContentPopup/index.style'
import Message from '@views/Popup/Message'
import BettingHistory from '@views/BettingHistory'
import ClubInfoPopUp from '@views/Popup/ClubInfo'
import { SimpleClubInfoItem } from '@store/clubStore'
import BettingListSelectorPopup from '@views/Popup/MessageContentPopup/BettingListSelectorPopup'
import TipDetail from '@views/Popup/TipDetail'
import MatchupBanner from '@views/Popup/MatchupBanner'
import MatchUpDetail from '@views/Matchup/MatchUpDetail'
import ItemHistory from '@views/Popup/ItemHistory'
import CouponInputPopup from '@views/Popup/Coupon/CouponInput'
import CouponCheckPopup from '@views/Popup/Coupon/CouponCheck'
import SkinDrawer from '@views/MyPage/SkinDrawer'
import EventGuideImg from '@assets/images/banner/tutorial-video/user-pick-benefit-detail-banner.jpg'
import SettingLimitPopup from '@views/Popup/SettingLimit'
import LossLimitSettingPopup from '@views/Popup/LossLimitSettingPopup'
import VocPagePopup from '@views/Popup/VocPagePopup'
import RankingPopup from '@views/Popup/RankingPopup'
import UsageGuideVideoPopup, {
  getUsageGuideVideoPlaybackPolicy,
  UsageGuideVideoPopupEntry,
} from '@views/Popup/UsageGuideVideo'
import { useState } from 'react'
import StorageUtils from '@utils/storage-utils'

export const POPUP_IDS = {
  // 나도승부사 경기 분석 팝업창(분석글 팝업에서 동일한 팝업이 한번 더 뜨기 때문에 기존것을 닫기위해)
  USER_PICK_DETAIL_LIST: 'user_pick_detail_list',
}

/** 출처 URL 종류에 맞는 팝업 내용 — 유튜브·X 는 임베드 위젯, 그 밖은 iframe */
function renderSourceContents(link: string): JSX.Element {
  const kind = detectSourceUrlKind(link)
  if (kind === SOURCE_URL_KIND.YOUTUBE) {
    return <YouTubeEmbed url={link} width="100%"/>
  }
  if (kind === SOURCE_URL_KIND.X) {
    return <XEmbed url={link} width="100%"/>
  }
  return <SourceUrlPopup link={link}/>
}

export default class PopupUtils {

  static showBettingHistory(props: { onClick: () => void, pageType?: PAGE_TYPE }): void {
    let fromViewType = FROM_VIEW_TYPE.BETTING_HISTORY
    const { pageType = null } = props
    switch (pageType) {
      case PAGE_TYPE.USER_PICK:
      case PAGE_TYPE.USER_PICK_DETAIL:
      case PAGE_TYPE.USER_PICK_HOME:
      case PAGE_TYPE.USER_PICK_MATCH_FILTER:
      case PAGE_TYPE.USER_PICK_PROFILE:
        fromViewType = FROM_VIEW_TYPE.USER_PICK
        break
    }

    globalStore.addGeneralPopupProperties(
      <BettingListSelector
        pageType={props.pageType}
        onClick={props.onClick}/>, '베팅 내역',
      {
        wrapClassName: '',
        className: 'betting-list-popup',
        isScroll: false,
        custom: false,
        clsBtn: false,
        closeCallback: () => bettingHistoryStore.resetSelectedBettingHistory(fromViewType),
      },
    )
  }

  /**
   * closeCallback 함수는 우측 상단 X 버튼으로 닫을때 동작 한다.
   * @param fromView
   */
  static showUserPickEditor(fromView: FROM_VIEW_TYPE) {
    globalStore.addGeneralPopupProperties(<UserPickEditor fromView={fromView}/>, '분석글 작성', {
      wrapClassName: '',
      className: '',
      isScroll: false,
      custom: false,
      clsBtn: false,
      isUnableCloseBg: true,
      closeCallback: () => bettingHistoryStore.resetSelectedBettingHistory(fromView),
    })
  }

  static showUserPickList(params?: {
    favoriteMatchCallback?: (isAdded: boolean) => void
    fromView?: FROM_VIEW_TYPE
    targetUserPickId?: string
  }): void {
    globalStore.addGeneralPopupProperties(
      <UserPickContents
        favoriteMatchCallback={params?.favoriteMatchCallback}
        fromView={params?.fromView}
        targetUserPickId={params?.targetUserPickId}
      />,
      '경기 분석', {
        wrapClassName: '',
        className: '',
        isScroll: false,
        custom: false,
        clsBtn: false,
      }, null, POPUP_IDS.USER_PICK_DETAIL_LIST)
  }

  static showUserPickGiveawayInfo(): void {
    globalStore.addGeneralPopupProperties(<UserPickGiveawayInfo/>, '나도 승부사', {
      wrapClassName: '',
      className: '',
      isScroll: false,
      custom: false,
      clsBtn: false,
    })
  }

  static showUserPostingActivity(title: string, baseMonth?: string): void {
    globalStore.addGeneralPopupProperties(<PostingActivity baseMonth={baseMonth}/>, title, {
      wrapClassName: '',
      className: '',
      isScroll: true,
      custom: false,
      clsBtn: false,
    })
  }

  static showUserLikeActivity(title: string, params: { baseMonth?: string }): void {
    const { baseMonth } = params
    globalStore.addGeneralPopupProperties(<LikeActivity title={title} baseMonth={baseMonth}/>, title, {
      wrapClassName: '',
      className: '',
      isScroll: true,
      custom: false,
      clsBtn: false,
    })
  }

  static showUserCommentActivity(title: string, params: { initTabIndex?: number, baseMonth?: string }): void {
    const { initTabIndex, baseMonth } = params || {}
    globalStore.addGeneralPopupProperties(<CommentActivity initTabIndex={initTabIndex} baseMonth={baseMonth}/>, title, {
      wrapClassName: '',
      className: '',
      isScroll: true,
      custom: false,
      clsBtn: false,
    })
  }

  static showUserShareBettingHistory(title: string, params: { baseMonth?: string }): void {
    const { baseMonth } = params
    globalStore.addGeneralPopupProperties(<ShareBettingHistory baseMonth={baseMonth}/>, title, {
      wrapClassName: '',
      className: '',
      isScroll: true,
      custom: false,
      clsBtn: false,
    })
  }

  static showTodayUserPick(): void {
    userPickStore.saveLastBestUserPickIdToLocal()
    globalStore.addGeneralPopupProperties(<TodayUserPick/>, '오늘의 승부사', {
      wrapClassName: '',
      className: '',
      isScroll: true,
      custom: false,
      clsBtn: false,
      closeCallback: () => {
        logStore.writeButtonLog({ pageId: 'a050', buttonId: '001' }).catch(console.error)
      }
    })
  }

  static showUserDetailInfo(targetUserPromiseId: string): void {
    const popupId = 'adv-user-detail-info'
    globalStore.closeGeneralPopup(popupId)
    setTimeout(() => {
      bettingHistoryStore.resetSelectedBettingHistory(FROM_VIEW_TYPE.USER_DETAIL_INFO)
      bettingHistoryStore.setBettingHistoryInitProps({
        onlyMajorClub: false,
        fromViewType: FROM_VIEW_TYPE.USER_DETAIL_INFO,
      })
      globalStore.addGeneralPopupProperties(<UserDetailInfo targetUserPromiseId={targetUserPromiseId}/>, '프로필', {
        wrapClassName: '',
        className: '',
        isScroll: false,
        custom: false,
        clsBtn: false,
      }, null, popupId)
    }, 1)
  }

  static showUserActivityScore(): void {
    globalStore.addGeneralPopupProperties(<UserActivityScore/>, '활동점수', {
      wrapClassName: '',
      className: '',
      isScroll: true,
      custom: false,
      clsBtn: false,
      closeCallback: () => {
        logStore.writeButtonLog({ pageId: 'e030', buttonId: '001' }).catch(console.error)
      }
    })
  }

  static showActivityScoreListPopup(): void {
    globalStore.addGeneralPopupProperties(<ActivityHistory/>, '점수 내역', {
      wrapClassName: '',
      className: '',
      isScroll: true,
      custom: false,
      clsBtn: false,
    })
  }

  /**
   * 팝업의 타이틀을 변경 해준다.
   * @param baseClassName 기준이 되는 클래스명
   * @param changeTitle 변경할 타이틀
   */
  static changePopupTitle(baseClassName: string, changeTitle: string): void {
    const listViewElems = document.querySelectorAll(`.${baseClassName}`)
    let listViewElem: Element
    if (_.size(listViewElems) === 1) {
      listViewElem = listViewElems[0]
    } else { // 동일한 className 으로 2개 이상 팝업이 떠있을 경우 마지막 요소가 현재 보여지는 팝업이다.
      listViewElem = listViewElems[listViewElems.length - 1]
    }
    const content = listViewElem.closest('.am-modal-content')
    if (content) {
      const title = content.querySelector('.am-modal-header .am-modal-title h1.title')
      title.textContent = changeTitle
    }
  }

  static showAdvComments(params: {
    commentType: USER_COMMENT_TYPE, fromViewType: FROM_VIEW_TYPE,
    targetId: string, commentCount: number,
    callbackCreated: (comment: Schema$UserComment) => void,
    callbackDeleted: (comment: Schema$UserComment) => void,
    callbackUpdated?: (comment: Schema$UserComment) => void,
    callbackLiked?: (comment: Schema$UserComment) => void
  }): void {
    // 나도승부사 분석글 댓글과 프리미엄 분석가(TodayPick) 댓글 구분
    const popupId = `adv-comments-popup-${params.fromViewType}`
    globalStore.closeGeneralPopup(popupId)
    setTimeout(() => {
      const contentBody = (
        <AdvComment
          commentType={params.commentType}
          fromViewType={params.fromViewType}
          targetId={params.targetId}
          callbackCreated={params.callbackCreated}
          callbackDeleted={params.callbackDeleted}
          callbackUpdated={params.callbackUpdated}
          callbackLiked={params.callbackLiked}
        />
      )
      let title = `댓글 ${params.commentCount}`
      if (params.commentType === USER_COMMENT_TYPE.COMPANY_PICK_COMMENT) {
        title = `${title}`
      } else if (params.commentType === USER_COMMENT_TYPE.USER_PICK_COMMENT) {
        title = `나도승부사 ${title}`
      }
      globalStore.addGeneralPopupProperties(
        contentBody,
        title,
        {
          wrapClassName: '',
          className: '',
          isScroll: false,
          custom: false,
          clsBtn: false,
          closeCallback: () => bettingHistoryStore.resetSelectedBettingHistory(params.fromViewType),
        }, null, popupId)
    }, 1)
  }

  static showAdvCommentEditor(params: {
    popupId?: string
    className?: string
    commentTypeText?: string
    fromViewType: FROM_VIEW_TYPE
    commentProp: Schema$UserComment
    callbackCreated: (comment: Schema$UserComment) => void
    callbackUpdated: (comment: Schema$UserComment) => void
    callbackClose: () => void
  }): void {
    const contentBody = (
      <AdvCommentEditor
        className={params.className}
        fromViewType={params.fromViewType}
        commentProp={params.commentProp}
        callbackCreated={params.callbackCreated}
        callbackUpdated={params.callbackUpdated}
        callbackClose={params.callbackClose}
        singleMode
      />
    )
    globalStore.addGeneralPopupProperties(contentBody, `${params.commentTypeText} 수정`, {
      wrapClassName: '',
      className: '',
      isScroll: false,
      custom: false,
      clsBtn: false,
    }, null, params.popupId)
  }

  static showBlockManagementPopup(): void {
    globalStore.addGeneralPopupProperties(<UserBlockList/>, '차단관리', {
      wrapClassName: '',
      className: '',
      isScroll: true,
      custom: false,
      clsBtn: false,
    })
  }

  static showPopularSearchTermPopup(
    popularSearchTerm: Schema$PopularSearchTerm,
    closeCallback?: (closeType?: PopupCloseType) => void
  ): void {
    globalStore.addGeneralPopupProperties(<PopularSearchTermPopup popularSearchTerm={popularSearchTerm}/>, '이슈 키워드', {
      wrapClassName: '',
      className: 'cls-btn-bottom',
      isScroll: true,
      custom: false,
      clsBtn: true,
      closeCallback,
    })
  }

  static showNewsPopup(link): void {
    globalStore.addGeneralPopupProperties(<NewsPopup link={link}/>, '', {
      wrapClassName: '',
      className: '',
      isScroll: true,
      custom: false,
      clsBtn: false,
    })
  }

  /**
   * 스포츠정보 출처 URL 팝업 (#0011006)
   *
   * 유튜브·X 는 임베드 위젯으로 띄운다 — 내용에 맞춰 높이가 잡힌다.
   * 그 밖은 NewsPopup 복제본을 쓴다. 기존 showNewsPopup 은 인기 검색어 전용으로 남긴다
   */
  static showSourceUrlPopup(link: string): void {
    globalStore.addGeneralPopupProperties(renderSourceContents(link), '', {
      wrapClassName: '',
      className: '',
      isScroll: true,
      custom: false,
      clsBtn: false,
    })
  }

  static showManagedUserDetailPopup(params: { popupImgUrl: string; title?: string }): void {
    const { popupImgUrl, title = '' } = params
    globalStore.addGeneralPopupProperties(<AdvImg src={popupImgUrl} alt="" />, title, {
      wrapClassName: '',
      className: 'full-image-popup',
      isScroll: true,
      custom: false,
      clsBtn: false,
    })
  }

  static showSportIssuePopup(
    track: Schema$SimpleMatchTrack,
    matchId: number, pickUserInfos:
    Schema$SportTalkPickUserInfo[]
  ): void {
    globalStore.addGeneralPopupProperties(
      <SportIssuePopup
        track={track}
        matchId={matchId}
        pickUserInfos={pickUserInfos}
      />,
      '대시보드',
      {
        wrapClassName: '',
        className: '',
        isScroll: true,
        custom: false,
        clsBtn: false,
      },
    )
  }

  static showSportTalkPopup(params: {
    matchId: number
    isMatchClosed: boolean
    fromViewType?: FROM_VIEW_TYPE
  }): void {
    const { matchId, isMatchClosed, fromViewType } = params
    globalStore.addGeneralPopupProperties(
      <SportTalkPopup
        matchId={matchId}
        isMatchClosed={isMatchClosed}
        fromViewType={fromViewType}
      />,
      '스포츠톡',
      {
        wrapClassName: '',
        className: '',
        isScroll: true,
        custom: false,
        clsBtn: false,
      },
    )
  }

  static showFavoriteManagementPopup(): void {
    globalStore.addGeneralPopupProperties(<FavoriteUserList/>, '관심유저', {
      wrapClassName: '',
      className: '',
      isScroll: true,
      custom: false,
      clsBtn: false,
    })
  }

  static showMyPagePopup(closeCallback?: (closeType?: PopupCloseType) => void): void {
    globalStore.addGeneralPopupProperties(<MyPage/>, '마이 페이지', {
      className: 'my-page',
      isScroll: true,
      closeCallback,
    })
  }

  static showBettorFindPopup(): void {
    globalStore.addGeneralPopupProperties(<BettorFind/>, '베터 찾기', {
      isScroll: false,
      closeCallback: () => {
        logStore.writeButtonLog({ pageId: 'd050', buttonId: '001' }).catch(console.error)
      }
    })
  }

  static showBettingRulesPopup(): void {
    globalStore.addGeneralPopupProperties(<BettingRules/>, '베팅 규정', {
      closeCallback: () => {
        logStore.writeButtonLog({ pageId: 'd030', buttonId: '001' }).catch(console.error)
      }
    })
  }

  static showBettingRulesDetailPopup(): void {
    globalStore.addGeneralPopupProperties(<BettingRulesDetail/>, '상세내용')
  }

  static showNoticePopup(): void {
    globalStore.addGeneralPopupProperties(<Notice/>, '공지사항', {
      closeCallback: () => {
        logStore.writeButtonLog({ pageId: 'd060', buttonId: '001' }).catch(console.error)
      }
    })
  }

  static showNoticeDetailPopup(): void {
    globalStore.addGeneralPopupProperties(<NoticeDetail/>, '상세내용')
  }

  static showClubPopup(): void {
    globalStore.addGeneralPopupProperties(<Club/>, authStore.isSpecificClubMember ? '클럽정보' : '클럽이동', {
      closeCallback: () => {
        logStore.writeButtonLog({ pageId: 'd040', buttonId: '001' }).catch(console.error)
      }
    })
  }

  static showItemShopPopup(params?: GeneralPopupOptions): void {
    globalStore.addGeneralPopupProperties(<ItemShop/>, '상점', {
      closeCallback: () => {
        logStore.writeButtonLog({ pageId: 'd020', buttonId: '001' }).catch(console.error)
      },
      ...params,
    })
  }

  static showTelegramGuidePopup(
    {
      hasFloatingButton,
      ...params
    }: GeneralPopupOptions & { hasFloatingButton?: boolean } = {}
  ): void {
    globalStore.addGeneralPopupProperties(
      <TelegramGuide hasFloatingButton={hasFloatingButton}/>,
      '텔레그램 가이드', {
      ...params,
    })
  }

  static showCompanyPickDetailPopup(): void {
    const closeCallback = () => {
      logStore.writeButtonLog({ pageId: 'a010', buttonId: '001' }).catch(console.error)
      companyPickStore.setIsMatchupPageCall(false)
      if (!isMobile) {
        globalStore.closeDialog()
      }
      companyPickStore.setSelectedCompanyPick(null)
    }
    globalStore.addGeneralPopupProperties(<CompanyPickDetailPopup doCloseMessage={() => {
      closeCallback()
      globalStore.closeGeneralPopup()
    }}/>, '경기분석', {
      closeCallback
    })
  }

  static showFriendsInvitationPopup(): void {
    globalStore.addGeneralPopupProperties(<FriendsInvitation/>, '친구 초대', {
      className: 'my-page',
      closeCallback: () => {
        logStore.writeButtonLog({ pageId: 'e020', buttonId: '001' }).catch(console.error)
      }
    })
  }

  static showAttachedImagePopup({ imageSrc, imageAlt }: { imageSrc: string, imageAlt: string }): void {
    globalStore.addGeneralPopupProperties(
      <div css={UploadMessageImgStyle}>
        <img src={imageSrc} alt={imageAlt}/>
      </div>,
      '공유 이미지',
      { wrapClassName: '', className: '', isScroll: true, custom: false, clsBtn: false }
    )
  }

  static showMessagePopup(): void {
    globalStore.addGeneralPopupProperties(<Message/>, '메시지함', {
      closeCallback: () => {
        logStore.writeButtonLog({ pageId: 'f010', buttonId: '002' }).catch(console.error)
        if (globalStore.clubMessageMode && componentStore.extraClubId) {
          clubStore.fetchUnReadClubMessageCount(componentStore.extraClubId)
        }

        componentStore.setExtraClubId(null)
        globalStore.setClubMessageMode(false)
      },
      isAnimated: isMobile,
    })
  }

  static showBettingHistoryPopup(): void {
    globalStore.addGeneralPopupProperties(<BettingHistory/>, '베팅 내역', {
      wrapClassName: '',
      className: '',
      isScroll: false,
      custom: false,
      clsBtn: false,
      closeCallback: () => {
        logStore.writeButtonLog({ pageId: 'c010', buttonId: '002' }).catch(console.error)
      },
    })
  }

  static showClubInfoPopup({ club, onCloseClubDetail, onClickMatchup }: {
    club: SimpleClubInfoItem
    onCloseClubDetail?: () => void
    onClickMatchup?: (id: string) => void
  }): void {
    globalStore.addGeneralPopupProperties(
      <ClubInfoPopUp
        club={club}
        onCloseClubDetail={onCloseClubDetail}
        onClickMatchup={onClickMatchup}
      />,
      '클럽정보', {
        isAnimated: isMobile,
      }
    )
  }

  static showBettingListSelectorPopup(): void {
    globalStore.addGeneralPopupProperties(<BettingListSelectorPopup/>, '베팅 내역', {
      closeCallback: () => {
        bettingHistoryStore.setSelectedBettingHistoryByBettingRecordTrack(
          null, bettingHistoryStore.bettingHistoryInitProps.fromViewType,
        )
        globalStore.setVisibleBettingListPopup(false)
      },
      isAnimated: isMobile,
    })
  }

  static showTipDetailPopup(): void {
    globalStore.addGeneralPopupProperties(<TipDetail/>, '상세 내용', {
      closeCallback: () => {
        componentStore.setTipDetail(null)
      },
      isUnableCloseBg: true,
      isAnimated: isMobile,
    })
  }

  static showMatchupBannerPopup(params?: GeneralPopupOptions): void {
    globalStore.addGeneralPopupProperties(<MatchupBanner/>, '승부사 소식', {
      ...params,
      isAnimated: isMobile,
      wrapClassName: componentStore.selectedGameBanner.desc.includes("(페이백)") ? 'payment-reward-event-modal' : ''
    })
  }

  static showMatchUpDetail(title: string , closeCallback: () => void, titleCustom: React.ReactNode): void {
    globalStore.addGeneralPopupProperties(<MatchUpDetail/>, title, {
      wrapClassName: 'matchup-detail',
      className: '',
      contentClassName: 'full-popup-content',
      isScroll: true,
      custom: true,
      clsBtn: true,
      closeCallback,
      enableBackHistory: true,
    }, titleCustom)
  }

  static showItemHistoryPopup(): void {
    globalStore.addGeneralPopupProperties(<ItemHistory/>, '아이템 내역')
  }
  
  static showCouponInputPopup(): void {
    globalStore.addGeneralPopupProperties(<CouponInputPopup/>, '쿠폰 입력')
  }

  static showCouponCheckPopup(): void {
    globalStore.addGeneralPopupProperties(<CouponCheckPopup/>, '쿠폰 확인')
  }

  static showSkinDrawerPopup(): void {
    globalStore.addGeneralPopupProperties(<SkinDrawer/>, '보유중인 스킨', {
      className: 'title-clear',
      closeCallback: () => {
        globalStore.setVisibleChangeProfile(false)
      },
      isAnimated: isMobile,
    })
  }

  static showEventGuideImgPopup(): void {
    const EventGuideImgPopup = () => {
      return (
        <img src={EventGuideImg} alt="신규가입자를 위한 무료머니 이벤트 안내 이미지" style={{ width: '100%' }} loading="lazy"/>
      )
    }
    globalStore.addGeneralPopupProperties(<EventGuideImgPopup/>, '무료머니 이벤트 안내', {
      wrapClassName: '',
      className: 'adv-event',
      isScroll: true,
      custom: false,
      clsBtn: false,
    })
  }

  static showSettingLimitPopup(): void {
    globalStore.addGeneralPopupProperties(<SettingLimitPopup/>, '이용 설정', {
      isAnimated: isMobile,
    })
  }

  /**
   * onComplete은 "설정" 버튼으로 완료했을 때와 X·mask·뒤로가기로 닫았을 때 모두 정확히 한 번 호출된다.
   * "설정" 완료는 LossLimitSettingPopup이 globalStore.closeGeneralPopup()을 직접 호출해 닫으므로
   * GeneralPopup의 closeCallback(X·mask·뒤로가기 전용)을 거치지 않는다. 그래서 동일한 onComplete를
   * LossLimitSettingPopup에도 prop으로 내려 완료 버튼에서 직접 호출하게 한다.
   */
  static showLossLimitSettingPopup(onComplete?: () => void): void {
    globalStore.addGeneralPopupProperties(<LossLimitSettingPopup onComplete={onComplete}/>, '손실한도 설정', {
      className: 'title-clear',
      wrapClassName: 'loss-limit-setting-popup',
      isAnimated: isMobile,
      closeCallback: onComplete,
    })
  }

  static showVocPagePopup(): void {
    globalStore.addGeneralPopupProperties(<VocPagePopup/>, '고객의 소리', {
      isAnimated: isMobile,
      closeCallback: async () => {
        await vocStore.attendVoc()
      }
    })
  }

  static showRankingPopup(params?: GeneralPopupOptions): void {
    globalStore.addGeneralPopupProperties(<RankingPopup/>, '승부사 소식', {
      ...params,
      isAnimated: isMobile,
    })
  }

  static showUsageGuideVideo({
    entry,
    onClose,
  }: {
    entry: UsageGuideVideoPopupEntry
    onClose?: () => void
  }): void {
    const { forced: isForced } = getUsageGuideVideoPlaybackPolicy(entry)
    let isForcedPlaybackCompleted = false
    let isClosed = false
    let setRemainingSeconds: React.Dispatch<React.SetStateAction<number | null>>

    const closeUsageGuideVideo = () => {
      if (isClosed) {
        return
      }
      isClosed = true
      if (isForced && isForcedPlaybackCompleted) {
        StorageUtils.saveUsageGuideVideoWatched()
        // 완료 기록 실패가 팝업 닫힘을 막지 않도록 비동기로 처리한다.
        userStore.recordUsageGuideVideoWatched().catch(console.error)
      }
      globalStore.setUsageGuideVideoPopupPlaybackLocked(false)
      onClose?.()
    }

    const RemainingSeconds = () => {
      const [remainingSeconds, setRemainingSecondsState] = useState<number | null>(null)

      setRemainingSeconds = setRemainingSecondsState

      if (remainingSeconds === null) {
        return null
      }

      return (
        <div style={{ position: 'absolute', top: '2px', right: '4px', width: '40px', height: '40px', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 150 }}>
          <span style={{ width: '26px', height: '26px', display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: '50px', backgroundColor: '#2a323e', fontSize: '14px', fontWeight: '700', color: '#AAFF00' }}>
            {remainingSeconds}
          </span>
        </div>
      )
    }

    globalStore.setUsageGuideVideoPopupPlaybackLocked(isForced)
    globalStore.addGeneralPopupProperties(
      <UsageGuideVideoPopup
        entry={entry}
        setRemainingSeconds={(seconds) => {
          setRemainingSeconds?.(seconds)
        }}
        onRequestClose={() => {
          closeUsageGuideVideo()
          globalStore.closeGeneralPopup()
        }}
        onPlaybackCompletionChange={(completed) => {
          isForcedPlaybackCompleted = completed
        }}
      />,
      '이용방법',
      {
        isAnimated: isMobile,
        custom: true,
        isUnableCloseBg: isForced,
        isClosable: () => !globalStore.usageGuideVideoPopupPlaybackLocked,
        closeCallback: closeUsageGuideVideo,
      },
      <RemainingSeconds/>,
    )
  }
}
